export const ACCOUNTING_MODELS_FILTERS_SET = {
    customSets: [],
    staticSets: [
        {
            id: 'act',
            name: 'active models',
            default: true,
            fixed: true,
            filters: [
                {
                    name: 'Storage',
                    value: false,
                },
            ],
        },
        {
            id: 'storage',
            name: 'in storage',
            default: true,
            fixed: true,
            filters: [
                {
                    name: 'Storage',
                    value: true,
                },
            ],
        },
        {
            id: 'all',
            name: 'all models',
            default: true,
            fixed: true,
            filters: [],
        },
        {
            id: 'intown',
            name: 'in town',
            fixed: true,
            filters: [
                {
                    name: 'InTown',
                    value: true,
                },
            ],
        },
        {
            id: 'inagencysincelastmonth',
            name: 'in agency since last 30 days',
            fixed: true,
            filters: [{ name: 'InAgencyFrom', value: '{last30days}' }],
        },
    ],
};
